<template>
  <div v-if="!showDetails">
    <app-history @clicked="$router.push('/registers-history')" />
    <v-card class="form">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="2">
          <b>دسته بندی:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="4">
          <v-select :items="Object.keys(registers)" v-model="category"
            no-data-text="داده ای برای نمایش وجود ندارد."></v-select>
        </v-col>
      </v-row>
      <app-register v-for="index in categoryRegisters.length" :key="index" :index="index - 1"
        :register="categoryRegisters[index - 1]" :showDetails="false" @clicked="onClickRegister">
      </app-register>
    </v-card>
  </div>
  <div v-else>
    <v-card>
      <v-card-title class="info-title">
        <div class="text-center">
          {{ selectedRegister.Title }}
        </div>
      </v-card-title>
      <app-row icon="calendar-alt" title="مهلت ثبت نام:"
        :value="selectedRegister.SabtStart + ' تا ' + selectedRegister.SabtEnd" />
      <app-row icon="calendar-alt" title="تاریخ برگزاری:" :value="selectedRegister.TarikhStart + ' تا ' + selectedRegister.TarikhEnd
        " />

      <v-card-title style="margin: 0 25px">
        <span v-html="selectedRegister.DescriptionAsHtml"> </span>
      </v-card-title>
      <v-row class="ltr">
        <v-btn color="primary white--text" class="register" rounded @click="applyRequest">
          ثبت نام
        </v-btn>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import Register from "./NewRegister";
import DetailRow from "@/components/DetailRow";
import HistoryButton from "@/components/HistoryButton";
import { saveSabtenam } from "@/api/sabtenam";
export default {
  data() {
    return {
      category: "",
      selectedIndex: -1,
    };
  },
  components: {
    appRegister: Register,
    appRow: DetailRow,
    appHistory: HistoryButton,
  },
  created() {
    this.$store.dispatch("getAllRegisters").then(() => {
      if (Object.keys(this.registers).length > 0) {
        this.category = Object.keys(this.registers)[0];
      }
    });
  },
  computed: {
    registers() {
      return this.$store.getters.registers;
    },
    categoryRegisters() {
      return this.registers.hasOwnProperty(this.category)
        ? this.registers[this.category]
        : [];
    },
    showDetails() {
      return this.selectedIndex > -1;
    },
    selectedRegister() {
      return this.selectedIndex != -1
        ? this.categoryRegisters[this.selectedIndex]
        : {};
    },
  },
  methods: {
    /**
     * show available classes
     */
    onClickRegister(index) {


      this.$router.push({
        query: {

          index: index
        }
      });
    },
    /**
     * check user input and  then send khorooj request
     */
    applyRequest() {
      saveSabtenam(this.selectedRegister.DorehID)
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
        })

        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
  },
  watch: {

    '$route'(to, from) {
      this.selectedIndex = this.$route.query.index ?? -1;

    }
  },

};
</script>
<style scoped>
.form {
  display: flow-root;
}
</style>
